import Keycloak from 'keycloak-js';
import { AWSKeycloakService } from './AWSKeycloakService';

// rename to utility file
let _kc = new Keycloak('/keycloak.json');
let isAWSUserTokenValid = null;
let aWSKeycloakService = new AWSKeycloakService();

/* eslint-disable */
/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 * @param awsUserTokenPayload
 */
const initKeycloak = async (onAuthenticatedCallback, awsUserTokenPayload) => {
  if (awsUserTokenPayload) {
    isAWSUserTokenValid = await aWSKeycloakService.isTokenValid(
      awsUserTokenPayload.accessToken,
    );

    if (isAWSUserTokenValid) {
      await aWSKeycloakService.refreshToken(awsUserTokenPayload.refreshToken);
      onAuthenticatedCallback(aWSKeycloakService.getUser());
    }
  } else {
    _kc
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
      })
      // log out parsed token to see what user info is needed
      .then((authenticated) => {
        if (authenticated) {
          const curUser = {
            id: _kc.tokenParsed?.sub,
            name: _kc.tokenParsed?.name,
            email: _kc.tokenParsed?.email,
            resource_access: _kc.tokenParsed?.resource_access,
            realm_roles: _kc.tokenParsed?.roles,
          };
          onAuthenticatedCallback(curUser);
        } else {
          doLogin();
        }
      });
  }
};

const doLogin = _kc.login;

const doLogout = () => {
  if (isAWSUserTokenValid) {
    aWSKeycloakService.doLogout();
  } else {
    _kc.logout();
    sessionStorage.clear();
  }
};

const getToken = () =>
  isAWSUserTokenValid ? aWSKeycloakService.getToken() : _kc.token;

const getUser = () => {
  if (isAWSUserTokenValid) {
    return aWSKeycloakService.getUser();
  } else {
    return {
      id: null,
      name: _kc.tokenParsed?.name,
      email: _kc.tokenParsed?.email,
      resource_access: _kc.tokenParsed?.resource_access,
      realm_roles: _kc.tokenParsed?.roles,
    };
  }
};

const getUserById = async (user_id) => {
  await _kc.users?.findOne({ id: user_id });
};

const isLoggedIn = () =>
  isAWSUserTokenValid ? !!isAWSUserTokenValid : !!_kc.token;

const updateToken = async (successCallback) =>
  // refresh token without using old token, use admin-cli
  isAWSUserTokenValid
    ? await aWSKeycloakService.refreshToken().then(successCallback).catch()
    : await _kc.updateToken(5).then(successCallback).catch(doLogin);

const getUsername = () =>
  isAWSUserTokenValid
    ? aWSKeycloakService.getUsername()
    : _kc.tokenParsed?.preferred_username;

// Checks if User has the Realm Role, "bite-admin" (Super Admin User for all BITE groups)
const isBiteAdmin = () =>
  isAWSUserTokenValid
    ? aWSKeycloakService.isBiteAdmin()
    : _kc.tokenParsed?.roles.includes('bite-admin');

const isServiceAccount = () =>
  isAWSUserTokenValid
    ? aWSKeycloakService.isServiceAccount()
    : _kc.tokenParsed?.roles.includes('service-account');

// Checks if any roles in a roles array are realm roles
const hasRole = (roles) =>
  isAWSUserTokenValid
    ? aWSKeycloakService.hasRealmRoles(roles)
    : roles.some((role) => _kc.hasRealmRole(role));

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getUser,
  getUserById,
  hasRole,
  isBiteAdmin,
  isServiceAccount,
};

export default KeycloakService;
